export default __webpack_public_path__ + "static/Messaging Platform – Question Formats – 1280px-3f89b00eece83cfe3804b7ac1bcc6a1a.jpg";